var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cx, css } from "@emotion/css";
export var Button = function (_a) {
    var className = _a.className, active = _a.active, reversed = _a.reversed, buttonColor = _a.buttonColor, props = __rest(_a, ["className", "active", "reversed", "buttonColor"]);
    return (_jsx("span", __assign({}, props, { className: cx(className, css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          display: block;\n          cursor: pointer;\n          color: ", ";\n        "], ["\n          display: block;\n          cursor: pointer;\n          color: ", ";\n        "])), buttonColor
            ? buttonColor
            : active
                ? "rgb(255, 72, 90)"
                : "#000")) })));
};
export var Icon = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("span", __assign({}, props, { className: cx("material-icons", css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          font-size: 28px;\n          vertical-align: text-bottom;\n        "], ["\n          font-size: 28px;\n          vertical-align: text-bottom;\n        "]))), className) })));
};
export var Menu = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("div", __assign({}, props, { ref: ref, className: cx(className, css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            & > * {\n              display: inline-block;\n            }\n\n            & > * + * {\n              margin-left: 15px;\n            }\n          "], ["\n            & > * {\n              display: inline-block;\n            }\n\n            & > * + * {\n              margin-left: 15px;\n            }\n          "])))) })));
});
export var Toolbar = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx(Menu, __assign({}, props, { className: cx(className, css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          position: relative;\n          padding: 8px;\n          margin: 0px -20px;\n          border-bottom: 2px solid #eee;\n        "], ["\n          position: relative;\n          padding: 8px;\n          margin: 0px -20px;\n          border-bottom: 2px solid #eee;\n        "])))) })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
